<template>
  <!-- <div class="chart-content">
    <div class="chart" ref="myChart">
    </div>
  </div> -->
  <BaseBarTran90 :name='name' :xAxisName='xAxisName' :seriesName='seriesName' :getDataAction='getDataAction' :isShowCloseBtn='isShowCloseBtn' @SizeChange='sizeChange' @StateChange='stateChange'> </BaseBarTran90>
</template>

<script>
// import elementResizeDetectorMaker from "element-resize-detector";
import {
  GetSupplierInStockDatas
} from '@/api'
// import BaseReportMixin from '@/mixin/baseReport-mixin.js'

import BaseBarTran90 from './../baseBarTran90.vue'

export default ({
  components: {
    BaseBarTran90
  },
  // mixins: [BaseReportMixin],
  data () {
    return {
      getDataAction: GetSupplierInStockDatas,
      // myChart: null,
      // option: {},
      // data: [],
      // nameData: [],
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    },
    xAxisName: {
      type: String,
      default () {
        return '金额(万元)'
      }
    },
    seriesName: {
      type: String,
      default () {
        return '汇总金额'
      }
    },
  },
  //监听beforinfo值的变化
  watch: {
    // data: {
    //   handler (newVal, oldVal) {
    //     this.initOption()
    //     this.option.series[0].data = newVal
    //     if (!this.myChart) {
    //       this.myChart = this.$echarts.init(this.$refs['myChart'])
    //     }
    //     this.myChart.setOption(this.option);
    //   },
    //   deep: true
    // },
  },
  methods: {
    sizeChange (a, b, c, d) {
      this.$emit('SizeChange', a, b, c, d)
    },
    stateChange (a, b) {
      this.$emit('StateChange', a, b)
    },
    // // 获取列表
    // getData () {
    //   GetSupplierInStockDatas({})
    //     .then(res => {
    //       this.data = res.returnData.map(e => e.value);
    //       this.nameData = res.returnData.map(e => e.name);
    //       // console.log(res.returnData, "returnData")
    //       // console.log(res.returnData.values, "values")
    //       // console.log(res.returnData.names, "names")
    //       // console.log(res.returnData.lineValues, "lineValues")
    //     })
    // },
    // initOption () {
    //   let that = this;
    //   this.option = {
    //     title: {
    //       text: this.name,
    //       textStyle: {
    //         color: "#FFF" // 标题颜色
    //       },
    //     },
    //     tooltip: {
    //       trigger: 'axis',
    //       axisPointer: {
    //         type: 'cross',
    //         label: {
    //           backgroundColor: '#283b56'
    //         }
    //       }
    //     },
    //     toolbox: this.getToolBox(this),
    //     // dataZoom: {
    //     //   show: false,
    //     //   start: 0,
    //     //   end: 100
    //     // },
    //     yAxis: [
    //       {
    //         type: 'category',
    //         boundaryGap: true,
    //         data: this.nameData,
    //         axisLine: {
    //           show: true,
    //           lineStyle: {
    //             color: '#fff'
    //           }
    //         },
    //         axisLabel: {
    //           show: false,
    //         },
    //         // axisTick: {
    //         //   show: true // 不显示坐标轴刻度线
    //         // },
    //       }
    //     ],
    //     xAxis: [
    //       {
    //         type: 'value',
    //         scale: true,
    //         name: '金额(万元)',
    //         // max: 700,
    //         // interval: 100,
    //         min: 0,
    //         // boundaryGap: [0.2, 0.2],
    //         nameTextStyle: {
    //           color: "#fff", // 蓝色
    //           fontSize: 12,
    //         },
    //         nameLocation: 'middle',
    //         nameGap: 25,
    //         axisLine: {
    //           // show: false,//坐标轴线
    //           show: true,
    //           lineStyle: {
    //             color: '#fff'
    //           }
    //         },
    //         splitLine: {
    //           show: false
    //         }
    //       }
    //     ],
    //     series: [
    //       {
    //         name: '备货数量',
    //         type: 'bar',
    //         barWidth: 10,
    //         data: this.data,
    //         label: {
    //           show: true,
    //           color: '#fff',
    //           align: 'left',
    //           offset: [20, 0],
    //           formatter: function (e) {
    //             return e.name
    //           },
    //           position: 'left'
    //           // verticalAlign: "top",
    //         }
    //       }
    //     ],
    //     grid: {
    //       left: '5%',
    //       show: false
    //     }
    //   }
    // },


    // init () {
    //   this.initOption()
    //   // this.option.width = this.width
    //   // this.option.height = this.height
    //   this.myChart = this.$echarts.init(this.$refs['myChart'])
    //   this.myChart.setOption(this.option);

    //   // // 随窗口的大小变化自适应
    //   // window.addEventListener("resize", function () {
    //   //   myChart.resize();
    //   // });
    //   //  随外层div的大小变化自适应
    //   const _this = this
    //   let erd = elementResizeDetectorMaker();
    //   erd.listenTo(this.$refs.myChart, (e) => {
    //     _this.$nextTick(() => {
    //       _this.myChart.resize();

    //       // var parentNodeId = e.parentNode.id
    //       // var domId = document.getElementById(parentNodeId);

    //       // _this.$emit('SizeChange', domId.clientWidth, domId.clientHeight, parentNodeId)
    //     })
    //   })
    // },

  },//自定义指令


  mounted () {
    // this.init()
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    // this.getData();
  },
})
</script>
<style scoped lang="scss">
// .chart-content {
//   width: 100%;
//   height: 400px;
//   display: flex;
//   .chart {
//     width: 400px;
//     height: 400px;
//     position: absolute; // 拖动时报表随div缩放
//   }
// }
</style>
